import React, { Component } from 'react';
import { motion } from 'framer-motion';
import GoogleMapReact from 'google-map-react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const MapMarker = () => (
  <div style={{
    width: '42px', height: '42px',
    background: 'linear-gradient(135deg, #c61515, #780e0f)',
    borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
    boxShadow: '0 4px 22px rgba(198,21,21,0.65)', border: '3px solid white',
    transform: 'translate(-50%, -50%)',
  }}>
    <LocationOnIcon style={{ color: 'white', fontSize: '20px' }} />
  </div>
);

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shop: {
        shopName: 'PhoneClinic4u Limited Hanley',
        address: '6 Upper Market Square, Stoke On Trent, ST1 1NS.',
        tradingAs: '(TA Phone Village)',
        lat: 53.02647114516705,
        lng: -2.174355870157202,
        email: 'info@phoneclinic4u.co.uk',
        call: '01782287557',
        weekDays: '9 am – 6 pm',
        weekEndSat: '9 am – 6 pm',
        weekEndSun: '10 am – 5 pm',
      },
    };
  }

  render() {
    const { shop } = this.state;

    const infoCards = [
      {
        Icon: LocationOnIcon,
        label: 'ADDRESS',
        main: shop.address,
        sub: shop.tradingAs,
      },
      {
        Icon: CallIcon,
        label: 'PHONE',
        main: shop.call,
        sub: 'Call us during opening hours',
        href: `tel:${shop.call}`,
      },
      {
        Icon: MailOutlineIcon,
        label: 'EMAIL',
        main: shop.email,
        sub: 'We reply within 24 hours',
        href: `mailto:${shop.email}`,
      },
      {
        Icon: AccessTimeIcon,
        label: 'OPENING HOURS',
        main: `Mon – Fri: ${shop.weekDays}`,
        sub: `Sat: ${shop.weekEndSat}  ·  Sun: ${shop.weekEndSun}`,
      },
    ];

    return (
      <div style={{ background: '#080808', paddingTop: '78px' }}>

        {/* ── Hero ── */}
        <section style={{
          minHeight: '44vh',
          background: 'linear-gradient(135deg, #0d0d0d 0%, #110404 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          position: 'relative', overflow: 'hidden', padding: '70px 5%',
        }}>
          <div style={{
            position: 'absolute', top: '-20%', left: '-5%', width: '420px', height: '420px',
            borderRadius: '50%', pointerEvents: 'none',
            background: 'radial-gradient(circle, rgba(198,21,21,0.1) 0%, transparent 70%)',
          }} />
          <div style={{
            position: 'absolute', inset: 0, pointerEvents: 'none',
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.012) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.012) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }} />
          <motion.div
            initial={{ opacity: 0, y: 34 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
            style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}
          >
            <div style={{ fontSize: '11px', letterSpacing: '4px', color: '#c61515', fontWeight: '800', marginBottom: '18px' }}>
              GET IN TOUCH
            </div>
            <h1 style={{ color: 'white', fontSize: 'clamp(32px, 5.5vw, 58px)', fontWeight: '900', margin: '0 0 20px', lineHeight: '1.1' }}>
              Contact{' '}
              <span style={{
                background: 'linear-gradient(135deg, #dd4d4e, #780e0f)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
              }}>
                Us
              </span>
            </h1>
            <p style={{ color: '#777', fontSize: '15px', maxWidth: '480px', margin: '0 auto', lineHeight: '1.85' }}>
              Visit our head office or reach out through any of our contact channels.
            </p>
          </motion.div>
        </section>

        {/* ── Info Cards ── */}
        <section style={{ padding: '80px 5% 40px', background: '#080808' }}>
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '18px', maxWidth: '1200px', margin: '0 auto',
          }}>
            {infoCards.map((card, i) => (
              <motion.div
                key={card.label}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0, transition: { delay: i * 0.1, duration: 0.5 } }}
                viewport={{ once: true }}
                whileHover={{ y: -6, borderColor: 'rgba(198,21,21,0.4)' }}
                transition={{ duration: 0.25 }}
                style={{
                  background: 'rgba(255,255,255,0.025)',
                  border: '1px solid rgba(255,255,255,0.07)',
                  borderRadius: '16px', padding: '28px 22px',
                  display: 'flex', gap: '16px', alignItems: 'flex-start',
                }}
              >
                <div style={{
                  width: '46px', height: '46px', flexShrink: 0,
                  background: 'rgba(198,21,21,0.1)', border: '1px solid rgba(198,21,21,0.2)',
                  borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <card.Icon style={{ color: '#c61515', fontSize: '22px' }} />
                </div>
                <div>
                  <div style={{ fontSize: '10px', letterSpacing: '2.5px', color: '#c61515', fontWeight: '800', marginBottom: '6px' }}>
                    {card.label}
                  </div>
                  {card.href
                    ? <a href={card.href} style={{ color: 'white', fontSize: '14px', fontWeight: '700', textDecoration: 'none', display: 'block', marginBottom: '4px' }}>{card.main}</a>
                    : <div style={{ color: 'white', fontSize: '14px', fontWeight: '700', marginBottom: '4px' }}>{card.main}</div>
                  }
                  <div style={{ color: '#555', fontSize: '12px', lineHeight: '1.5' }}>{card.sub}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* ── Map ── */}
        <section style={{ padding: '0 5% 90px', background: '#080808' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <motion.div
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.6 }}
              style={{
                borderRadius: '20px', overflow: 'hidden',
                border: '1px solid rgba(198,21,21,0.2)',
                height: '440px', position: 'relative',
              }}
            >
              <GoogleMapReact
                bootstrapURLKeys={{ key: '' }}
                defaultCenter={{ lat: shop.lat, lng: shop.lng }}
                defaultZoom={15}
              >
                <MapMarker lat={shop.lat} lng={shop.lng} />
              </GoogleMapReact>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
              viewport={{ once: true }} transition={{ delay: 0.2 }}
              style={{
                background: 'rgba(255,255,255,0.025)',
                border: '1px solid rgba(255,255,255,0.07)',
                borderRadius: '14px', padding: '20px 24px', marginTop: '14px',
                display: 'flex', justifyContent: 'space-between',
                flexWrap: 'wrap', gap: '16px', alignItems: 'center',
              }}
            >
              <div>
                <h5 style={{ color: 'white', fontWeight: '800', margin: '0 0 4px', fontSize: '15px' }}>{shop.shopName}</h5>
                <p style={{ color: '#555', margin: 0, fontSize: '13px' }}>{shop.address} {shop.tradingAs}</p>
              </div>
              <a
                href={`https://maps.google.com/?q=${shop.lat},${shop.lng}`}
                target="_blank" rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <motion.button
                  whileHover={{ scale: 1.05, boxShadow: '0 0 22px rgba(198,21,21,0.4)' }}
                  whileTap={{ scale: 0.95 }}
                  style={{
                    background: 'linear-gradient(135deg, #c61515, #780e0f)',
                    color: 'white', border: 'none', padding: '10px 22px',
                    borderRadius: '8px', fontSize: '12px', letterSpacing: '1.5px',
                    fontWeight: '800', cursor: 'pointer', fontFamily: 'Catamaran, sans-serif',
                  }}
                >
                  GET DIRECTIONS
                </motion.button>
              </a>
            </motion.div>
          </div>
        </section>
      </div>
    );
  }
}

export default Contact;
